import { Brain, MessageCircle, Shield, ArrowRight, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import PhoneFrame from "./mockups/PhoneFrame";
import BeamyChatMockup from "./mockups/BeamyChatMockup";

const BeamySection = () => {
  const { t } = useLanguage();
  const scrollToWaitlist = () => document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="beamy" className="py-24 bg-ink-800 relative overflow-hidden">
      <div className="absolute top-20 right-10 w-96 h-96 bg-violet/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <div className="eyebrow mb-4 inline-flex items-center gap-2">
            <Bot className="h-3.5 w-3.5" />
            {t("beamy.badge")}
          </div>
          <h2 className="font-display text-5xl md:text-6xl text-white mb-5 leading-[1.0]">
            {t("beamy.title1")}
            <em className="italic text-violet">{t("beamy.title2")}</em>{t("beamy.title3")}
          </h2>
          <p className="text-xl text-violet font-display italic mb-4">{t("beamy.tagline")}</p>
          <p className="text-base text-white/60 leading-relaxed">{t("beamy.desc")}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-4 order-2 lg:order-1">
            {[
              { icon: Brain, titleKey: "beamy.personal.title", descKey: "beamy.personal.desc" },
              { icon: MessageCircle, titleKey: "beamy.honest.title", descKey: "beamy.honest.desc" },
              { icon: Shield, titleKey: "beamy.swiss.title", descKey: "beamy.swiss.desc" },
            ].map((card, i) => (
              <div key={i} className="bg-ink-700 border border-white/[0.06] p-6 rounded-3xl">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-violet/15 flex items-center justify-center flex-shrink-0">
                    <card.icon className="h-5 w-5 text-violet" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-2xl text-white mb-2">{t(card.titleKey)}</h3>
                    <p className="text-white/60 text-sm leading-relaxed">{t(card.descKey)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="relative order-1 lg:order-2 flex justify-center">
            <div className="absolute -inset-8 bg-violet/20 blur-3xl rounded-full pointer-events-none" />
            <PhoneFrame scale={0.78}>
              <BeamyChatMockup mode="dark" />
            </PhoneFrame>
          </div>
        </div>

        <div className="mt-16 bg-violet rounded-3xl px-8 py-12 text-center">
          <h4 className="font-display text-3xl md:text-4xl text-ink-800 mb-6">{t("beamy.cta")}</h4>
          <Button onClick={scrollToWaitlist} className="bg-ink-800 hover:bg-ink-900 text-white rounded-full px-8 py-3 font-semibold uppercase tracking-wider text-sm">
            {t("beamy.ctaButton")}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BeamySection;
